import api from '../../api/mas-athena';

const state = {
    checkout: []
};

const getters = {
    checkoutDetails: state => state.checkout
};

const actions = {
    async getCheckout({ commit }, booking_id) {
        const response = await api.getCheckout(booking_id)
        
        commit('setCheckout', await response.data.results);
    }    
};

const mutations = {
    setCheckout: (state, checkout) => {
        state.checkout = checkout
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
